import { useInstance } from '../support/ioc/useInstance';
import { useSubscription } from '@autopylot-internal/state';
import { PaywallDialogViewModel } from './PaywallDialogViewModel.tsx';
import { RevenueCatModel } from './revenue-cat/RevenueCatModel.ts';
import { PaywallIcon } from '../components/icons/Icons.tsx';
import { MenuItem } from '../menu/MenuItem.tsx';

export const PaywallMenuButton: React.FC = () => {
    const paywall = useInstance(PaywallDialogViewModel);

    const revenueCat = useInstance(RevenueCatModel);
    useSubscription(() => revenueCat);

    let label = 'AutoPylot+';
    if (!revenueCat.hasUpgraded() && revenueCat.isEligibleForTrial()) {
        label = paywall.isPromotionActive() ? `Get AutoPylot+ ${paywall.getPromotionConfig().savingPct}% off` : 'Try AutoPylot+ for $0';
    }

    const onClick = () => {
        paywall.open({ triggerSource: 'menu button' });
    };

    return (
        <div data-id="paywall-menu-button" data-type={revenueCat.hasUpgraded() ? 'downgrade' : 'upgrade'}>
            <MenuItem
                title={label}
                icon={PaywallIcon}
                color="primary"
                small
                bold
                onClick={onClick}
            />
        </div>
    );
};
